const STORAGE_KEY = "breadcrumb:context";
const COLLECTION_SEGMENT = /^(.*\/collections\/([^/?#]+))/;

// Native /search only redirects; Searchspring serves results from a collection.
const searchCollection = document.querySelector(
    ".breadcrumbs[data-search-collection]",
)?.dataset.searchCollection;

function pageContext(path) {
    if (path.includes("/products/")) return { kind: "product", key: "product" };

    const collection = path.match(COLLECTION_SEGMENT);
    if (!collection) return null;

    if (searchCollection && collection[2] === searchCollection) {
        return { kind: "search", key: "search" };
    }

    return { kind: "collection", key: collection[2], base: collection[1] };
}

function sameTarget(a, b) {
    return Boolean(a) && Boolean(b) && a.kind === b.kind && a.key === b.key;
}

function readContext() {
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    } catch {
        return null;
    }
}

// Searchspring applies filters and sorting through history.pushState, so the
// URL is only final once the shopper leaves the page.
function remember(context) {
    try {
        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                kind: context.kind,
                key: context.key,
                url: window.location.pathname + window.location.search,
            }),
        );
    } catch {
        return;
    }
}

function referrerContext() {
    if (!document.referrer) return null;

    try {
        const url = new URL(document.referrer);
        if (url.origin !== window.location.origin) return null;
        return pageContext(url.pathname);
    } catch {
        return null;
    }
}

// Searchspring renders the grid from its own bundle and links straight to
// /products/*, which drops the collection the shopper is browsing.
function scopeGridLinks(base) {
    const scope = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const link = target.closest('a[href^="/"][href*="/products/"]');
        if (!link?.closest("#searchspring-content")) return;

        const href = link.getAttribute("href");
        if (href.includes("/collections/")) return;

        link.setAttribute(
            "href",
            base + href.slice(href.indexOf("/products/")),
        );
    };

    for (const type of ["pointerdown", "click", "auxclick", "contextmenu"]) {
        document.addEventListener(type, scope, true);
    }
}

function restoreFilters(stored) {
    for (const link of document.querySelectorAll("a[data-restore-filters]")) {
        if (link.dataset.restoreFilters === stored.key) {
            link.setAttribute("href", stored.url);
        }
    }
}

function isModifiedClick(event) {
    return (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
    );
}

// A fresh load makes Searchspring rebuild the grid from scratch and lose the
// sort, so step back through history instead when that is where we came from.
function enableHistoryBack(key) {
    if (window.history.length <= 1) return;

    document.addEventListener("click", (event) => {
        if (event.defaultPrevented || isModifiedClick(event)) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const link = target.closest("a[data-restore-filters]");
        if (link?.dataset.restoreFilters !== key) return;

        event.preventDefault();
        window.history.back();
    });
}

function applyStoredContext() {
    const stored = readContext();
    if (!stored?.key || !stored.url) return;

    restoreFilters(stored);

    if (sameTarget(referrerContext(), stored)) enableHistoryBack(stored.key);
}

const context = pageContext(window.location.pathname);

if (context?.kind === "collection" || context?.kind === "search") {
    remember(context);
    if (context.base) scopeGridLinks(context.base);
    window.addEventListener("pagehide", () => remember(context));
} else {
    applyStoredContext();
}
